import { Select, Table } from "antd";
import { useState } from "react";
import { HISTORY_ACTION_LABEL, PAGE_SIZE, REASON_LABEL, STATUS_LABEL } from "features/ConsultRequest/core/constants";
import { formatDateTime } from "features/ConsultRequest/core/utils";
import { listHistories } from "features/ConsultRequest/data/apiAdapters";
import { useConsultQuery } from "features/ConsultRequest/data/hooks";
import ConsultErrorState from "./ConsultErrorState";

const detailText = (h) =>
  [
    h.fromValue || h.toValue
      ? `${STATUS_LABEL[h.fromValue] || h.fromValue || ""} → ${STATUS_LABEL[h.toValue] || h.toValue || ""}`
      : null,
    h.reason && `Lý do: ${REASON_LABEL[h.reason] || h.reason}`,
    h.note && `Ghi chú: ${h.note}`,
  ]
    .filter(Boolean)
    .join(" · ");

// Mỗi thao tác ghi thành công bắt đầu lại ở trang 1, không lọc, để hiện sự kiện mới nhất.
export default function HistoryTab({ requestId, refreshToken }) {
  return <HistoryContent key={`${requestId}:${refreshToken}`} requestId={requestId} />;
}

function HistoryContent({ requestId }) {
  const [page, setPage] = useState(1);
  const [action, setAction] = useState(undefined);
  const history = useConsultQuery(listHistories, [requestId, { page, size: PAGE_SIZE, ...(action ? { action } : {}) }]);
  if (history.error)
    return <ConsultErrorState error={{ message: "Không tải được tiến độ" }} onRetry={history.refetch} />;
  const columns = [
    { title: "THỜI GIAN", width: 180, render: (_, h) => formatDateTime(h.createdAt, { seconds: false }) },
    { title: "NGƯỜI THỰC HIỆN", width: 220, render: (_, h) => h.actor?.name || "Hệ thống" },
    { title: "SỰ KIỆN", width: 180, render: (_, h) => HISTORY_ACTION_LABEL[h.action] || h.action },
    { title: "CHI TIẾT", render: (_, h) => detailText(h) },
  ];
  return (
    <div>
      <Select
        allowClear
        placeholder="Tất cả sự kiện"
        style={{ width: 220, marginBottom: 12 }}
        value={action}
        onChange={(v) => {
          setAction(v);
          setPage(1);
        }}
        options={Object.entries(HISTORY_ACTION_LABEL).map(([value, label]) => ({ value, label }))}
      />
      <Table
        rowKey="id"
        loading={history.loading}
        columns={columns}
        dataSource={history.data?.items || []}
        pagination={{
          current: page,
          pageSize: PAGE_SIZE,
          total: history.data?.total || 0,
          showSizeChanger: false,
          onChange: setPage,
        }}
      />
    </div>
  );
}
